export default "__VITE_ASSET__BtJW85Vx__"